import React from 'react';
import { DashboardLayout } from '../components/dashboard';
import { Page, PageHeader } from '../components/ui';
import { useAuth } from '../contexts/AuthContext';
import { NotificationHistory } from '../features/notifications/components/NotificationHistory';
import { PreferencesPanel } from '../features/notifications/components/PreferencesPanel';
import { useMailStatus } from '../features/notifications/useNotifications';

/** A person's own notification settings: what reaches them, and what already did. */
export const NotificationSettingsPage: React.FC = () => {
  const { user } = useAuth();
  const mailStatus = useMailStatus();

  return (
    <DashboardLayout>
      <Page>
        <PageHeader title="Notifications" meta={user?.email ? `Sent to ${user.email}` : undefined} />
        <PreferencesPanel mailStatus={mailStatus} />
        <NotificationHistory className="mt-8" />
      </Page>
    </DashboardLayout>
  );
};

export default NotificationSettingsPage;
